<template>
  <div ref="el" :class="classes">
    <div>
      <div class="nb-banner-inline-texts">
        <div class="flex no-wrap">
          <NbIcon
            v-if="symbol"
            :symbol="symbol"
            :color="color !== 'neutral' ? `oncolor-${color}` : ''"
            class="nb-banner-inline-icon"
          />
          <slot name="title">
            <span v-if="text" class="nb-banner-inline-text" v-html="text"></span>
          </slot>
        </div>
        <slot name="description">
          <span v-if="description" class="nb-banner-inline-description" v-html="description"></span>
        </slot>
      </div>
      <div
        v-if="(buttonGhostLabel || buttonSecondaryLabel || closeButton) && type !== 'stacked'"
        class="nb-banner-inline-actions"
      >
        <div v-if="buttonGhostLabel || buttonSecondaryLabel" class="nb-banner-inline-action">
          <NbButton
            v-if="buttonGhostLabel"
            color="ghost"
            :label="buttonGhostLabel"
            @click="handleBannerInlineGhostButtonClick($event)"
          />
          <NbButton
            v-if="buttonSecondaryLabel"
            color="secondary"
            :label="buttonSecondaryLabel"
            @click="handleBannerInlineSecondaryButtonClick($event)"
          />
        </div>
        <div v-if="closeButton" :class="closeClasses">
          <NbButton type="icon" color="ghost" @click="handleBannerInlineButtonClose($event)" />
        </div>
      </div>
      <div v-else-if="closeButton && type === 'stacked'" class="nb-banner-inline-actions">
        <div v-if="closeButton" class="nb-banner-inline-close">
          <NbButton type="icon" color="ghost" @click="handleBannerInlineButtonClose($event)" />
        </div>
      </div>
    </div>
    <div
      v-if="(buttonGhostLabel || buttonSecondaryLabel) && type === 'stacked'"
      class="nb-banner-inline-stacked-actions"
    >
      <div v-if="buttonGhostLabel || buttonSecondaryLabel" class="nb-banner-inline-action">
        <NbButton
          v-if="buttonSecondaryLabel"
          color="secondary"
          :label="buttonSecondaryLabel"
          @click="handleBannerInlineSecondaryButtonClick($event)"
        />
        <NbButton
          v-if="buttonGhostLabel"
          color="ghost"
          :label="buttonGhostLabel"
          @click="handleBannerInlineGhostButtonClick($event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import '../scss/components/nb-banner-inline.scss'
import NbIcon from './NbIcon.vue'
import NbButton from './NbButton.vue'
import { ref, computed, onMounted, onUpdated } from 'vue'
import type { NbBannersInline } from './NbBanners'
const emit = defineEmits<{
  (e: 'clickghost', ev: Event): void
  (e: 'clicksecondary', ev: Event): void
  (e: 'close', ev: Event): void
}>()
const props = withDefaults(defineProps<NbBannersInline>(), {
  text: '',
  description: '',
  buttonGhostLabel: '',
  buttonSecondaryLabel: '',
  buttonGhostCloses: false,
  buttonSecondaryCloses: false,
  closeButton: true,
  type: 'single',
  symbol: 'globe',
  color: 'neutral'
})
const classes = computed(() => ({
  'nb-banner-inline': true,
  'nb-banner-inline-multi': props.type === 'multi' && props.description,
  'nb-banner-inline-stacked': props.type === 'stacked' && props.description,
  [`nb-bg-${props.color}`]: true
}))
const closeClasses = computed(() => ({
  'nb-banner-inline-close': true,
  'nb-banner-inline-close-border': props.buttonGhostLabel || props.buttonSecondaryLabel
}))
const handleBannerInlineGhostButtonClick = (e: Event) => {
  if (props.buttonGhostCloses) {
    disableBannerInline(el.value)
  }
  emit('clickghost', e)
}
const handleBannerInlineSecondaryButtonClick = (e: Event) => {
  if (props.buttonSecondaryCloses) {
    disableBannerInline(el.value)
  }
  emit('clicksecondary', e)
}
const handleBannerInlineButtonClose = (e: Event) => {
  disableBannerInline(el.value)
  emit('close', e)
}
const disableBannerInline = (e: Element) => {
  e.classList.remove('nb-banner-inline-active')
}
const enableBannerInline = (e: Element) => {
  const bannerInlineTimeout = setTimeout(addBannerInline, 50, e)
}
const addBannerInline = (e: Element) => {
  e.classList.add('nb-banner-inline-active')
}
const el = ref()
onMounted(() => {
  enableBannerInline(el.value)
})
onUpdated(() => {
  enableBannerInline(el.value)
})
</script>
